export const PROD = 'devotions';
export const DEV = 'devotions-2023';
export const DB = process.env.NODE_ENV !== 'production' ? DEV : PROD;